import styled from 'styled-components'

import { Card as DefaultCard } from '@/components/ui/card'

export const Card = styled(DefaultCard)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BadgeContainer = styled.span`
  display: inline-flex;
  max-width: max-content;
  flex-shrink: 0;
`

export const TooltipList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space['4']};
`

export const AssigneeRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space['4']};
`

export const AssigneeTwoLines = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`
